import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { UserService } from "../../../../shared";
import { SchoolService } from "../../../../shared/services/school.service";
import { DataService_FacilitySetup } from "../shared/data.service";
import { FacilityRequestModel } from "../shared/FacilityRequestModel";
import { LocationModel } from "../shared/LocationModel";

@Component({
	selector: "app-district-edit-facility",
	templateUrl: "./district-edit-facility.component.html",
	styleUrls: ["./district-edit-facility.component.css"],
})
export class DistrictEditFacilityComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private facilityService: DataService_FacilitySetup,
		private confirmationService: ConfirmationService,
		private userService: UserService,
		private schoolService: SchoolService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.SelectedFacility = this.dialogConfig.data.SelectedFacility;
		this.FacilityID = this.SelectedFacility.FacilityID;

		this.loadFacilityData();
	}

	////////////////////////////////////////
	// Data
	////////////////////////////////////////

	EditMode: any = true;

	Saving: any = false;
	DataLoading: any = true;

	//Data From Parent
	SelectedFacility: any;
	RawFacilityData: any;

	FacilityID: any;

	user: any;

	CurrentScreen: any = 0;

	MenuSelect = "Name";
	lstMenuItems = ["Name", "Locations", "Schools", "ScanStation", "Visitor Pass"];

	////////////////////////
	//Data from all pages:
	////////////////////////

	//Page 1
	FacilityName: any = "";
	FacilityCode: any = "";
	Phone: any = "";
	Address: any = "";
	City: any = "";
	State: any = "";
	Zip: any = "";
	DefinedByID: any = 4;

	//Page 2
	lstLocations: any = [];

	//Page 3
	lstSchool: any = [];
	lstOriginalSchool: any = [];

	//Page 4
	ScanStationData: any;

	//Page 5
	EnableOffenderSearch: any;
	VerificationPassID: any;

	//Page 6
	MSDefaultPassID: any;
	MSOffenderHitPassID: any;
	MSVerificationPassID: any;

	////////////////////////

	////////////////////////////////////////

	////////////////////////////////////////
	// Load Data
	////////////////////////////////////////
	loadFacilityData() {
		this.DataLoading = true;

		var result = this.facilityService.FacilityLoadData(this.SelectedFacility.FacilityID);
		result.subscribe(
			(response) => {
				this.RawFacilityData = response[0];

				this.UpdateData();

				this.DataLoading = false;
			},
			(error) => {
				this.DataLoading = false;
			}
		);
	}

	UpdateData() {
		//Page 1
		this.FacilityName = this.RawFacilityData.FacilityName;
		this.FacilityCode = this.RawFacilityData.FacilityCode;
		this.DefinedByID = this.RawFacilityData.DefinedByID;
		this.Phone = this.RawFacilityData.Phone;
		this.Address = this.RawFacilityData.Address;
		this.City = this.RawFacilityData.City;
		this.State = this.RawFacilityData.State;
		this.Zip = this.RawFacilityData.Zip;

		//Page 2
		this.lstLocations = this.RawFacilityData.lstLocations;

		//Page 3
		this.lstSchool = this.GetSchools(this.RawFacilityData.lstSchoolIDs);
		// this.lstOriginalSchool = this.GetSchools(this.RawFacilityData.lstSchoolIDs);

		//Scan Station Data
		var ssd: any = {
			AwayBarcode: this.RawFacilityData.AwayBarcode == 1 ? true : false,
			AwayPhoto: this.RawFacilityData.AwayPhoto == 1 ? true : false,
			EnableMealAccounting: this.RawFacilityData.EnableMealAccounting == 1 ? true : false,
			EnablePersonalItem: this.RawFacilityData.EnablePersonalItem == 1 ? true : false,
		};

		this.ScanStationData = ssd;

		//Visitor Pass
		this.EnableOffenderSearch = this.RawFacilityData.EnableOffenderSearch == 1 ? true : false;
		this.VerificationPassID = this.RawFacilityData.VerificationPassID;

		//MS Visitor Pass
		this.MSDefaultPassID = this.RawFacilityData.MSDefaultPassID;
		this.MSOffenderHitPassID = this.RawFacilityData.MSOffenderHitPassID;
		this.MSVerificationPassID = this.RawFacilityData.MSVerificationPassID;
	}

	GetSchools(lstIDs) {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				var allSchools: any = response;

				this.lstSchool = [];
				this.lstOriginalSchool = [];

				for (var i = 0; i < allSchools.length; i++) {
					var next = allSchools[i];
					for (var x = 0; x < lstIDs.length; x++) {
						if (next.SchoolID == lstIDs[x]) {
							this.lstSchool = [...this.lstSchool, next];
							this.lstOriginalSchool = [...this.lstOriginalSchool, next];
						}
					}
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////

	////////////////////////////////////////
	// Buttons
	////////////////////////////////////////

	onNavClick(val) {
		this.MenuSelect = this.lstMenuItems[val];
		this.CurrentScreen = val;

		//
		// Edit mode (and in general?)
		// Don't need to clear because values are
		// independent of each other?
		//

		//Clear future pages

		//Clear 2nd page
		// if(val < 1){
		//   this.lstLocations = [];
		// }
		// if(val < 2){
		//   this.lstSchool = [];
		// }
		// if(val < 3){
		//   this.ScanStationData = undefined;
		// }
	}

	onNextClick(val) {
		//Update main data
		var d = val.Data;

		if (d != undefined) {
			//1st Page:
			if (d.FacilityName != undefined) {
				this.FacilityName = d.FacilityName;
			}
			if (d.FacilityCode != undefined) {
				this.FacilityCode = d.FacilityCode;
			}
			if (d.Phone != undefined) {
				this.Phone = d.Phone;
			}
			if (d.Address != undefined) {
				this.Address = d.Address;
			}
			if (d.City != undefined) {
				this.City = d.City;
			}
			if (d.State != undefined) {
				this.State = d.State;
			}
			if (d.Zip != undefined) {
				this.Zip = d.Zip;
			}

			//2nd Page:
			if (d.lstLocations != undefined) {
				this.lstLocations = d.lstLocations;
			}

			//3rd Page:
			if (d.lstSchool != undefined) {
				this.lstSchool = d.lstSchool;
			}

			//4th Page
			if (d.EnableMealAccounting != undefined) {
				this.ScanStationData = d;
			}

			//5th Page
			if (d.EnableOffenderSearch != undefined) {
				this.EnableOffenderSearch = d.EnableOffenderSearch;
			}
			if (d.VerificationPassID != undefined) {
				this.VerificationPassID = d.VerificationPassID;
			}
		}

		this.onNavClick(val.NextPage);
		this.CurrentScreen = val.NextPage;
	}

	onFinished(val) {
		this.Saving = true;

		//Get data from MS Visitor Pass (last page)
		this.MSDefaultPassID = val.DefaultPassID;
		this.MSOffenderHitPassID = val.OffenderHitPassID;
		this.MSVerificationPassID = val.VerificationPassID;

		var FormattedLocations: LocationModel[] = [];
		for (var i = 0; i < this.lstLocations.length; i++) {
			var next = this.lstLocations[i];

			let loc: LocationModel = {
				FacilityLocationID: next.FacilityLocationID,
				Active: next.ActiveDesc == "Active" ? 1 : 0,
				FacilityLocationCD: next.FacilityLocationCD,
				FacilityLocationName: next.FacilityLocationName,
			};

			FormattedLocations = [...FormattedLocations, loc];
		}

		var FormattedSchools: number[] = [];
		for (var i = 0; i < this.lstSchool.length; i++) {
			var next = this.lstSchool[i];

			FormattedSchools = [...FormattedSchools, Number(next.SchoolID)];
		}

		var DefinedBy: number = this.user.UserLevelID == 1 ? 4 : 3; //

		//Create request model to create the facility
		let parms: FacilityRequestModel = {
			FacilityID: this.SelectedFacility.FacilityID,
			FacilityName: this.FacilityName,
			FacilityCode: this.FacilityCode,
			Phone: this.Phone,
			Address: this.Address,
			City: this.City,
			State: this.State,
			Zip: this.Zip,
			DefinedByID: DefinedBy,
			lstLocations: FormattedLocations,
			lstSchoolIDs: FormattedSchools,
			EnableMealAccounting: this.ScanStationData.EnableMealAccounting == true ? 1 : 0,
			EnablePersonalItem: this.ScanStationData.EnablePersonalItem == true ? 1 : 0,
			AwayBarcode: this.ScanStationData.AwayBarcode == true ? 1 : 0,
			AwayPhoto: this.ScanStationData.AwayPhoto == true ? 1 : 0,
			EnableOffenderSearch: this.EnableOffenderSearch == true ? 1 : 0,
			VerificationPassID: this.VerificationPassID,
			MSDefaultPassID: this.MSDefaultPassID,
			MSOffenderHitPassID: this.MSOffenderHitPassID,
			MSVerificationPassID: this.MSVerificationPassID,
		};

		var result = this.facilityService.FacilityUpdate(parms);
		result.subscribe(
			(response) => {
				this.Saving = false;

				if (response) {
					//Success
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Facility was created successfully",
						header: "Facility Maintenance",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Error
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not create the facility",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Saving = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	////////////////////////////////////////

	////////////////////////////////////////
	// Helpers
	////////////////////////////////////////

	DisableButton(btn) {
		// return btn > this.CurrentScreen;
		// return false;
		return this.Saving == true;
	}

	////////////////////////////////////////
}
